(function () {
    'use strict';

    angular
        .module('app.scoring')
        .component('sc3ScoringHeader', {
            templateUrl: 'app/scoring/scoring-header/scoring-header.component.html',
            controller: ScoringHeaderComponent,
            bindings: {
                profile: '<'
            }
        });

    var noop = angular.noop;

    ScoringHeaderComponent.$inject = ['user', 'defaultClubLogoUrl', 'toggleFriend'];
    function ScoringHeaderComponent(user, defaultClubLogoUrl, toggleFriend) {
        var ctrl = this,
            mediaReadLink = 'logo@odata.mediaReadLink';

        // Properties
        Object.defineProperty(ctrl, 'clubLogo', { get: getClubLogo });
        Object.defineProperty(ctrl, 'userId', { get: getUserId });
        ctrl.allowScorePosting = user.allowScorePosting;
        ctrl.isAdmin = user.isAdmin;

        // Methods
        ctrl.isCurrentUser = isCurrentUser;
        ctrl.toggleFriend = toggleFriend;
        ctrl.clubLogoError = clubLogoError;

        //////////////////////////////////////////

        function isCurrentUser() {
            return user.id && user.id === ctrl.profile.individualId;
        }

        function getClubLogo() {
            var club = ctrl.profile.club;
            return club && club[mediaReadLink] || defaultClubLogoUrl;
        }

        function clubLogoError(e) {
            var club = ctrl.profile.club;
            if (club && club[mediaReadLink])
                delete club[mediaReadLink];
            else if (defaultClubLogoUrl)
                defaultClubLogoUrl = null;
        }

        function getUserId() {
            return user.id;
        }
    }
})();